import { createOptimisticAction } from 'Store/utils/createAction';
import type { AllInclusiveServicesCriteria } from 'Store/price-remote/all-inclusive-services/allInclusiveServices.helper';
import { fetchAllInclusiveServices } from 'Store/price-remote/all-inclusive-services/allInclusiveServices.helper';
import { ALL_INCLUSIVE_SERVICES_REQUEST } from 'Store/price-remote/constants';
export const getAllInclusiveServices = (
  appContext: AppContext,
  criteria: AllInclusiveServicesCriteria,
) => {
  return createOptimisticAction(
    ALL_INCLUSIVE_SERVICES_REQUEST,
    {},
    {
      optimist: true,
      promise: fetchAllInclusiveServices(appContext, criteria),
    },
  );
};
